import * as React from "react";
import { Button, Tooltip } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  visibilityName: string;
  contentName: string;
  children: React.ReactNode;
}
export const SecretCodeEditorObfuscated: React.FC<Props> = ({ visibilityName, contentName, children }) => {
  const { id } = useCpFormContext();
  const isEdit = useCpFormValue(`meta.isEdit`);
  const isVisible = useCpFormValue(visibilityName);
  const content = useCpFormValue(contentName) as string | undefined;

  if (!isEdit) {
    return <>{children}</>;
  }

  if (!content?.trim()) {
    return <>{children}</>;
  }

  if (isVisible) {
    return (
      <>
        <div className="flex justify-end mb-1">
          <Tooltip title="Hide">
            <Button
              size="small"
              icon={<EyeInvisibleOutlined />}
              onClick={() => formSetValue(id, visibilityName, false)}
            />
          </Tooltip>
        </div>
        {children}
      </>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      <div style={{ filter: "blur(10px)", pointerEvents: "none", userSelect: "none" }}>{children}</div>
      <div
        className="absolute inset-0 flex items-center justify-center z-10"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.1)", cursor: "pointer", borderRadius: 4 }}
        onClick={() => formSetValue(id, visibilityName, true)}
      >
        <Button icon={<EyeOutlined />}>Click to show</Button>
      </div>
    </div>
  );
};
